import { cx } from "./controlStyles";

// Loading placeholder. Sized by the caller via className — the primitive
// supplies the surface, the small radius and a gentle pulse (still for
// people who ask for reduced motion).

export function Skeleton({ className }: { className?: string }) {
  return (
    <div
      className={cx(
        "rounded-sm bg-[color:var(--c-glass-button-hover)] motion-safe:animate-pulse",
        className,
      )}
      aria-hidden
    />
  );
}
